<script setup>
import { __, convertEpochToLocalDate, convertSecondsToMinutes } from '@/utils'
// import { ref } from 'vue';
import WhiteBox from '@components/whiteBox/whiteBox.vue';
// import PurchaseInfo from './purchase-info.vue';
// import PackageProgress from './package-progress.vue';
// import UsageInfo from './usage-info.vue';
// import ModalDatepicker from './modal-datepicker.vue';
import PlanInfo from './plan-info.vue';
import ProgressCircle from '@components/progress-circle/progress-circle.vue';

// const dateModal = ref(false);

defineProps(['data'])

// const acceptDate = (data) => {
//     dateModal.value = false;
// }

// const openDatepicker = () => {
//     dateModal.value = true;
// }

const title = (item) => {
    if(item.call && item.sms) {
        return __('Using a call + SMS package')
    } else if(item.call) {
        return __('Using a calling package')
    } else if(item.sms) {
        return __('SMS package usage')
    }
}

const handleDays = (from, to) => {
    const fromDate = new Date(from * 1000);
    const toDate = new Date(to * 1000);
    const diffTime = Math.abs(toDate - fromDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

const boxCount = (item) => {
    let count = 0;
    const classes = ['', 'one', 'two', 'three'];

    if(item.call || item.sms || item.data) {
        count++;
    } 
    if(item.data?.group_balance) {
        count++;
    }

    return `${classes[count]}`;
}
</script>

<template>
    <h4>{{ __('package abroad') }}</h4>
    <WhiteBox v-for="(item, index) in data" :key="index" class="package-box">
        <div class="package-row" :class="`package-row--` + boxCount(item)">
            <PlanInfo :data="item">
                <p>
                    <template v-if="item.data?.service_details?.price?.[0].price">
                        {{ __('at the price of') }} <strong>{{ item.data?.service_details?.price?.[0].price }} ₪</strong><br />
                    </template>
                    {{ __('The package activation date is on') }} <strong>{{ convertEpochToLocalDate(item.from?.sec) }}</strong><br/>
                    <template v-if="!main">
                        {{ __('Valid for') }} - <strong>{{ handleDays(item.from?.sec, item.to?.sec) }} {{ __('days') }}</strong>
                    </template>
                </p>
            </PlanInfo>
         
            <!-- <PurchaseInfo /> -->

            <div class="divider" v-if="item.call || item.sms"></div>

            <div class="usage-info" v-if="item.call || item.sms">
                <h4 class="usage-info__header">
                    {{ title(item) }}
                </h4>
                <div class="usage-info__items">
                    <div class="usage-item" v-if="item.call">
                        <h5>{{ __('Calls') }}</h5>
                        <span class="gradient">{{ convertSecondsToMinutes(item.call.group_balance.usagev) }}<br /></span>
                        {{ __('Minutes out of') }}
                        {{ convertSecondsToMinutes(item.call.group_balance.total) }}
                    </div>
                    <div class="divider" v-if="item.sms"></div>
                    <div class="usage-item" v-if="item.sms">
                        <h5>{{ __('Messages') }}</h5>
                        <span class="gradient">{{ item.sms.group_balance.usagev }}<br /></span>
                        {{ __('Messages out of') }}
                        {{ item.sms.group_balance.total }}
                    </div>
                </div>
            </div>

            <div class="divider" v-if="item.roaming_data"></div>

            <!-- <PackageProgress /> -->
            <div class="package-progress" v-if="item.roaming_data">
                <div v-if="item.roaming_data.group_balance" class="package-progress__item">
                    <h4>{{ __('Using the browsing package') }}</h4>
                    <ProgressCircle
                        :title="__('eczema')"
                        :current="item.roaming_data.group_balance.usagev" 
                        start="0"
                        :end="item.roaming_data.group_balance?.total"
                        :disableUnit="item.roaming_data.group_balance.usage_type === 'roaming_call'"
                    />
                    <!-- Hide per request -->
                    <a href="/roaming" class="btn btn--black">{{ __('To purchase additional browsing volume') }}</a>
                </div>
            </div><!-- /.package-progress -->

            <div class="package-gradient">
                <!-- <img :src="`${theme_path.url}/resources/images/svg/icon-package-graphic.svg`" /> -->
                <img :src="`${theme_path.url}/resources/images/svg/icon-package-graphic-small.svg`" />
            </div>

            <!-- <ModalDatepicker
                @close="dateModal = false"
                @accept="acceptDate"
                :active="dateModal" 
            /> -->
        </div>
    </WhiteBox>
</template>